function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

/**
 * @module link/utils
 */
import { toMap } from 'ckeditor5/src/utils';
/**
 * Helper class that ties together all {@link module:link/link~LinkDecoratorAutomaticDefinition} and provides
 * the {@link module:engine/conversion/downcasthelpers~DowncastHelpers#attributeToElement downcast dispatchers} for them.
 */

var AutomaticDecorators = /*#__PURE__*/function () {
  function AutomaticDecorators() {
    _classCallCheck(this, AutomaticDecorators);

    /**
     * Stores the definition of {@link module:link/link~LinkDecoratorAutomaticDefinition automatic decorators}.
     * This data is used as a source for a downcast dispatcher to create a proper conversion to output data.
     *
     * @private
     * @type {Set}
     */
    this._definitions = new Set();
  }
  /**
   * Gives information about the number of decorators stored in the {@link module:link/utils~AutomaticDecorators} instance.
   *
   * @readonly
   * @protected
   * @type {Number}
   */


  _createClass(AutomaticDecorators, [{
    key: "length",
    get: function get() {
      return this._definitions.size;
    }
    /**
     * Adds automatic decorator objects or an array with them to be used during downcasting.
     *
     * @param {module:link/link~LinkDecoratorAutomaticDefinition|Array.<module:link/link~LinkDecoratorAutomaticDefinition>} item
     * A configuration object of automatic rules for decorating links. It might also be an array of such objects.
     */

  }, {
    key: "add",
    value: function add(item) {
      var _this = this;

      if (Array.isArray(item)) {
        item.forEach(function (item) {
          return _this._definitions.add(item);
        });
      } else {
        this._definitions.add(item);
      }
    }
    /**
     * Provides the conversion helper used in the {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add} method.
     *
     * @returns {Function} A dispatcher function used as conversion helper
     * in {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add}.
     */

  }, {
    key: "getDispatcher",
    value: function getDispatcher() {
      var _this2 = this;

      return function (dispatcher) {
        dispatcher.on('attribute:linkHref', function (evt, data, conversionApi) {
          // There is only test as this behavior decorates links and
          // it is run before dispatcher which actually consumes this node.
          // This allows on writing own dispatcher with highest priority,
          // which blocks both native converter and this additional decoration.
          if (!conversionApi.consumable.test(data.item, 'attribute:linkHref')) {
            return;
          }

          var viewWriter = conversionApi.writer;
          var viewSelection = viewWriter.document.selection;

          var _iterator = _createForOfIteratorHelper(_this2._definitions),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              var viewElement = viewWriter.createAttributeElement('a', item.attributes, {
                priority: 5
              });
              viewWriter.setCustomProperty('link', true, viewElement);

              if (item.callback(data.attributeNewValue)) {
                if (data.item.is('selection')) {
                  viewWriter.wrap(viewSelection.getFirstRange(), viewElement);
                } else {
                  viewWriter.wrap(conversionApi.mapper.toViewRange(data.range), viewElement);
                }
              } else {
                viewWriter.unwrap(conversionApi.mapper.toViewRange(data.range), viewElement);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }, {
          priority: 'high'
        });
      };
    }
    /**
     * Provides the conversion helper used in the {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add} method
     * when linking images.
     *
     * @returns {Function} A dispatcher function used as conversion helper
     * in {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add}.
     */

  }, {
    key: "getDispatcherForLinkedImage",
    value: function getDispatcherForLinkedImage() {
      var _this3 = this;

      return function (dispatcher) {
        dispatcher.on('attribute:linkHref:imageBlock', function (evt, data, conversionApi) {
          var viewFigure = conversionApi.mapper.toViewElement(data.item);
          var linkInImage = Array.from(viewFigure.getChildren()).find(function (child) {
            return child.name === 'a';
          });

          var _iterator2 = _createForOfIteratorHelper(_this3._definitions),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item = _step2.value;
              var attributes = toMap(item.attributes);

              if (item.callback(data.attributeNewValue)) {
                var _iterator3 = _createForOfIteratorHelper(attributes),
                    _step3;

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var _ref3 = _step3.value;

                    var _ref2 = _slicedToArray(_ref3, 2);

                    var key = _ref2[0];
                    var val = _ref2[1];

                    if (key === 'class') {
                      conversionApi.writer.addClass(val, linkInImage);
                    } else {
                      conversionApi.writer.setAttribute(key, val, linkInImage);
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              } else {
                var _iterator4 = _createForOfIteratorHelper(attributes),
                    _step4;

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var _ref6 = _step4.value;

                    var _ref5 = _slicedToArray(_ref6, 2);

                    var _key = _ref5[0];
                    var _val = _ref5[1];

                    if (_key === 'class') {
                      conversionApi.writer.removeClass(_val, linkInImage);
                    } else {
                      conversionApi.writer.removeAttribute(_key, linkInImage);
                    }
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        });
      };
    }
  }]);

  return AutomaticDecorators;
}();

export { AutomaticDecorators as default };